import { render, staticRenderFns } from "./ProductSkuAutocomplete.vue?vue&type=template&id=bf31d8fe"
import script from "./ProductSkuAutocomplete.vue?vue&type=script&lang=ts"
export * from "./ProductSkuAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf31d8fe')) {
      api.createRecord('bf31d8fe', component.options)
    } else {
      api.reload('bf31d8fe', component.options)
    }
    module.hot.accept("./ProductSkuAutocomplete.vue?vue&type=template&id=bf31d8fe", function () {
      api.rerender('bf31d8fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductSkuAutocomplete.vue"
export default component.exports